import { getAssetByTypeAndSource } from 'Pods/ThreeDStudio/Shared/Utils/getAssetByTypeAndSource'
import { ACTION, PROVIDER } from 'Pods/ThreeDStudio/Store/constants'

import { deriveMaterialForTripo3D } from './deriveMaterialForTripo3D'
import { getModelFormatOutput } from './getModelFormatOutput'
import { normalizeRunAttributes } from './normalizeRunAttributes'

/**
 * Builds the ThreeDStudio store patch for a Tripo3D text-to-3d-default run.
 * Maps polyCount/topology/materialMode from the run, derives material via
 * deriveMaterialForTripo3D, infers modelFormatOutput from the generated
 * 3d_model URL when not explicit, and opens the model settings panel.
 *
 * @param {Object} openedModel - Run object from the library
 * @returns {Object} parsedData - ThreeDStudio store patch
 */
export const parseTripo3dTextTo3dDefaultData = (openedModel) => {
  const {
    id: sessionId,
    generatorSessionId,
    modelFormatOutput: rawModelFormatOutput,
    prompt,
    private: isPrivate,
    outputAssets,
    useCase,
  } = openedModel

  const {
    polyCount: targetPolycount,
    topology: polygonType,
    materialMode,
    generateType,
  } = normalizeRunAttributes(openedModel.providerRunAttributes)
  const material = deriveMaterialForTripo3D(materialMode)
  const {
    assetId: inputThreeD,
    fileUrl: inputThreeDUrl,
  } = getAssetByTypeAndSource(outputAssets, '3d_model', 'ai_generated')
  const modelFormatOutput = getModelFormatOutput({
    modelFormatOutput: rawModelFormatOutput,
    modelUrl: inputThreeDUrl,
  })
  const generationProvider = PROVIDER.TRIPO3D
  const generationAction = ACTION.TEXT_TO_3D
  const isSmartLowPoly = generateType === 'LowPoly'

  const schema = { generationAction, generationProvider }
  const generation = { sessionId, generatorSessionId }
  // Topology is the only setting Tripo P1 (smart low poly) drops, so it is the
  // only one missing from the round-trip.
  const modelSettings = {
    material,
    targetPolycount,
    ...(isSmartLowPoly ? {} : { polygonType }),
    isPrivate,
    prompt,
    isSmartLowPoly,
    selectedUseCase: useCase,
  }
  const viewer = { fileFormat: modelFormatOutput, inputThreeD, material }
  const ui = {
    isModelSettingsOpen: true,
    isViewerSidebarOpen: false,
    activeViewerSidebarTab: undefined,
  }

  return {
    openedModel,
    schema,
    modelSettings,
    ui,
    generation,
    viewer,
  }
}
